var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:baseline-search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.14 11.2938H12.5146L12.2929 11.08C13.0955 10.1491 13.5367 8.9605 13.5358 7.73128C13.5358 6.71353 13.234 5.71864 12.6686 4.87241C12.1031 4.02619 11.2995 3.36663 10.3592 2.97715C9.41892 2.58768 8.38427 2.48577 7.38607 2.68433C6.38788 2.88288 5.47098 3.37297 4.75132 4.09263C4.03166 4.81229 3.54157 5.72919 3.34302 6.72738C3.14447 7.72558 3.24637 8.76023 3.63585 9.70051C4.02532 10.6408 4.68488 11.4445 5.5311 12.0099C6.37733 12.5753 7.37223 12.8771 8.38998 12.8771C9.66456 12.8771 10.8362 12.41 11.7387 11.6342L11.9525 11.8559V12.4813L15.9108 16.4317L17.0904 15.2521L13.14 11.2938ZM8.38998 11.2938C6.41873 11.2938 4.82748 9.70253 4.82748 7.73128C4.82748 5.76003 6.41873 4.16878 8.38998 4.16878C10.3612 4.16878 11.9525 5.76003 11.9525 7.73128C11.9525 9.70253 10.3612 11.2938 8.38998 11.2938Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.051f1c5b975a40fdc6ef7a8f859e255e.svg";
export { ForwardRef as ReactComponent };